function Waypoints() {
	var self = this;
	this.init();
}

Waypoints.prototype.init = function() {
	var self = this;
	this.showItemsOnLoad();
	this.showItemsOnScroll();
};

Waypoints.prototype.showItemsOnLoad = function() {
	var self = this;
	$(window).on('load', function() {
		$('.load-wpt').addClass('-active');
	});
};

Waypoints.prototype.showItemsOnScroll = function() {
	var self = this;
	$('.wpt').each(function(i, el) {
		el.waypoint = new Waypoint({
			element: el,
			handler: function(dir) {
				if (dir == "down") {
					if (!$(el).hasClass('-active')) {
						$(el).addClass('-active');
						
						if ($(el).find('.responsive-background.lazy').length) {
							if ($(el).find('.responsive-background.lazy').find('img:not(.lazy)').attr('src') === undefined)
								app.images.bindElement($(el).find('.responsive-background.lazy').find('img:not(.lazy)'));
						}
					}
				} else {
					if ($(el).hasClass('-active')) {
						$(el).removeClass('-active');
					}
				}
			},
			offset: '85%'
		});
	});
	// $('.image-reveal').each(function(i, el) {
	// 	var that = $(this);
	// 	that.waypoint = new Waypoint({
	// 		element: el,
	// 		handler: function(dir) {
	// 			if (!that.hasClass('-scrolled')) {
	// 				that.addClass('-scrolled');
	// 				setTimeout(function() {
	// 					that.addClass('-visible');
	// 					setTimeout(function() {
	// 						that.addClass('-hidden-mask');
	// 					}, 600);
	// 				}, 600);
	// 			}
	// 		},
	// 		offset: '50%'
	// 	});
	// });
};